import { Component, ElementRef, inject, OnInit, Signal, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Environment } from '@environment/environment';
import { LoaderComponent } from '@progress/kendo-angular-indicators'
import { DialogContainerDirective } from '@progress/kendo-angular-dialog'
import { LoaderService } from '@services/loader/loader.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { PerformSyncNotifierService } from '@services/perform/perform-sync-notifier/perform-sync-notifier.service';
import { TextBoxDirective } from '@progress/kendo-angular-inputs';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { AlertService, PromptOptions } from '@services/alert/alert.service';
import { TranslateService } from '@codeandweb/ngx-translate';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DialogContainerDirective, LoaderComponent, TextBoxDirective, ButtonDirective],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  private readonly loaderSvc: LoaderService = inject(LoaderService)
  private readonly alertSvc: AlertService = inject(AlertService)
  private readonly translateSvc: TranslateService = inject(TranslateService)
  private readonly performNotifierSvc: PerformSyncNotifierService = inject(PerformSyncNotifierService)

  loaderMsg = toSignal(this.loaderSvc.loaderObs.asObservable().pipe(map(data => data.message)), { initialValue: 'Please wait' })
  private readonly loaderRef = viewChild<ElementRef<HTMLDialogElement>>('loaderWrapper');
  private readonly promptRef = viewChild<ElementRef<HTMLDialogElement>>('promptWrapper');
  private readonly promptInputRef = viewChild<ElementRef<HTMLInputElement>>('promptInput');

  promptOptions: Signal<PromptOptions | undefined> = toSignal(this.alertSvc.promptSubject.asObservable().pipe(
    filter(promptOptions => promptOptions.action === 'prompt'),
    map(promptOptions => promptOptions.options)
  ))

  // promptTitle = signal<string>('')
  // promptMessage = signal<string>('')
  // promptOkBtnTxt = signal<string>('')
  // promptCancelBtnTxt = signal<string>('')
  // promptPlaceholderTxt = signal<string>('')

  constructor() {

  }

  #notifyPerformSync() {
    this.performNotifierSvc.notifyPerformSyncNotifier('app-launch')
  }

  ngOnInit(): void {
    console.log('active environment : ', Environment.environment)
    this.handleLoader();
    this.handlePrompt()
    setTimeout(() => {

      this.#notifyPerformSync();

    }, 1000);
  }

  handleLoader() {


    this.loaderRef()?.nativeElement.addEventListener('cancel', (event) => {
      event.preventDefault();  // stops the default cancel event which would close the dialog
    });

    this.loaderRef()?.nativeElement.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault(); // stops the default close on Esc
      }
    });

    this.loaderSvc.loaderObs.subscribe(options => {
      if (options.visibility) {
        this.loaderRef()?.nativeElement.showModal();
      } else {
        this.loaderRef()?.nativeElement.close();
      }
    })
  }

  handlePrompt() {
    setTimeout(() => {
      const dialog = this.promptRef()?.nativeElement;
      dialog?.addEventListener('cancel', (e) => {
        this.promptRef()?.nativeElement.close();
        this.alertSvc.promptSubject.next({
          action: 'result',
          result: undefined
        })
        if (this.promptInputRef()?.nativeElement) {
          (this.promptInputRef() as ElementRef<HTMLInputElement>).nativeElement.value = '';
        }
      })
    }, 1000);

    this.alertSvc.promptSubject.asObservable().subscribe(promptOptions => {
      if (promptOptions.action !== 'prompt') {
        return;
      }
      // this.promptTitle.set(promptOptions?.options?.title ?? this.translateSvc.instant('promptTitle'))
      // this.promptMessage.set(promptOptions?.options?.message ?? '');
      // this.promptOkBtnTxt.set(promptOptions?.options?.okButtonText ?? this.translateSvc.instant('okBtnTxt'))
      // this.promptCancelBtnTxt.set(promptOptions?.options?.cancelButtonText ?? this.translateSvc.instant('cancelBtnTxt'));
      // this.promptPlaceholderTxt.set(promptOptions?.options?.placeholderText ?? this.translateSvc.instant('promptPlaceholder'));

      this.promptRef()?.nativeElement.showModal();

    })
  }

  onPromptActionBtnClick(textBox: HTMLInputElement, action: 'ok' | 'cancel') {
    this.promptRef()?.nativeElement.close();
    this.alertSvc.promptSubject.next({
      action: 'result',
      result: action == 'ok' ? textBox.value : undefined
    })
    textBox.value = '';
    // this.promptTitle.set(this.translateSvc.instant('promptTitle'))
    //   this.promptMessage.set('');
    //   this.promptOkBtnTxt.set(this.translateSvc.instant('okBtnTxt'))
    //   this.promptCancelBtnTxt.set(this.translateSvc.instant('cancelBtnTxt'));
    //   this.promptPlaceholderTxt.set(this.translateSvc.instant('promptPlaceholder'));
  }

}
